import { Injectable, signal } from '@angular/core';

@Injectable()
export class SidebarStateService {
  #minimised = signal(false);
  #settingsOpen = signal(false);

  minimised = this.#minimised.asReadonly();
  settingsOpen = this.#settingsOpen.asReadonly();

  setMinimised = (value: boolean) => this.#minimised.set(value);
  toggleSettings = () => this.#settingsOpen.update((v) => !v);
}
